const { default: Tabs } = require("components/Tabs")
const { default: styled } = require("styled-components")

export const StyledTabs = styled(Tabs)`
  position: sticky;
  top: ${(p) => p.theme.headerHeight}px;
  z-index: 9;
`
